const ambassadors = {
  name: 'Ambassadeur',
};

export default ambassadors;
